import { OperationsMenuActions } from '../../constants';

export const changeEmbeddingType = (embeddingType) => ({
  type: OperationsMenuActions.SAVE_CHANGE_TYPE,
  embeddingType,
});

export const changeEmbeddingSubType = (embeddingSubType) => ({
  type: OperationsMenuActions.SAVE_CHANGE_SUB_TYPE,
  embeddingSubType,
});
